import React from 'react';
import DistanceProvider from './distanceContext';
import Views from './views';

import './index.scss';

const Distances = () => {
  return (
    <div className="nav-page-content">
      <div className="app-distances">
        <DistanceProvider>
          <Views />
        </DistanceProvider>
      </div>
    </div>
  );
};

export default Distances;
